<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">Admin - {{ data?.name }}</h3>
          <p class="page-head__sub">Profile Details</p>
        </div>
      </div>
    </div>


    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="row  all-details" >
            <div class="col-md-6">

              <div class="card-header border-right row " style="height: 100% !important;">

                <div class="col-md-5 heading">Full name</div>
                <div class="col-md-7 detail">{{data?.name}}</div>


                @if (data?.permission === 'admin') {
                  <div class="col-md-5 heading">IMTO Name</div>
                }
                @if (data?.permission === 'admin') {
                  <div class="col-md-7 details">@if ($safeNavigationMigration(data?.agent) !== null) {
                    <a [routerLink]="['/agent',$safeNavigationMigration(data?.agent?.slug)]" >{{data?.agent.name}}</a>
                  }</div>
                }

                <div class="col-md-5 heading">Telephone</div>
                <div class="col-md-7 details">{{data?.phone_number || 'Not specified'}}</div>


                <div class="col-md-5 heading">Email</div>
                <div class="col-md-7 details">{{data?.email}}</div>

              </div>

            </div>
            <div class="col-md-6">
              <div class="card-header border-right no-border row" style="height: 100% !important;">

                <div class="col-md-5 heading">Admin Level</div>
                <div class="col-md-7 details"><button class="btn btn-outline-info round">{{adminLevel($safeNavigationMigration(data?.permission))}}</button></div>

                <div class="col-md-5 heading">Address</div>
                <div class="col-md-7 detail">{{data?.address  || 'Not specified'}}</div>

                <div class="col-md-5 heading">State/Province</div>
                <div class="col-md-7 details">{{data?.city?.name  || 'Not specified'}}</div>

                <div class="col-md-5 heading">Country</div>
                <div class="col-md-7 details">{{data?.country?.name  || 'Not specified'}}</div>

              </div>

            </div>


          </div>
        </div>
      </div>


    </div>


  </div>
</div>
<app-bottombar></app-bottombar>
